import { Volume2, VolumeX } from 'lucide-react';
import { useAmbientSound } from '../../hooks/useAmbientSound';

export function AudioToggle({ compact = false }: { compact?: boolean }) {
  const { enabled, toggle } = useAmbientSound();
  return (
    <button
      className="audio-toggle"
      type="button"
      onClick={toggle}
      aria-pressed={enabled}
      aria-label={enabled ? 'Silenciar atmósfera' : 'Activar atmósfera sonora'}
      title={enabled ? 'Silenciar atmósfera' : 'Activar atmósfera sonora'}
    >
      {enabled ? <Volume2 aria-hidden="true" /> : <VolumeX aria-hidden="true" />}
      {!compact && <span>{enabled ? 'Sonido activo' : 'Sin sonido'}</span>}
    </button>
  );
}
